import { SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR } from 'api/actionTypes';

export default async function assignLeadApartmentLocator(
  { state, apiClient },
  {
    userId,
    assignmentContext,
    displayContext,
    enableSmsMessage,
    canOverwrite,
    delay,
    apartmentLocatorUserId,
  },
) {
  await apiClient.postWithState({
    action: SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR,
    state: state,
    payload: {
      userId,
      assignmentContext,
      displayContext,
      enableSmsMessage,
      canOverwrite,
      delay,
      apartmentLocatorUserId,
    },
  });
}
